<div class="main-div">
    <mat-card>
        <mat-card-content>
            <form [formGroup]="form">
                <img src="./../../assets/img/pmb-go.png" class="fullWidth">
                <mat-form-field class="full-width-input">
                    <input matInput placeholder="Username" formControlName="username" required>
                </mat-form-field>
                <mat-form-field class="full-width-input">
                    <input matInput [type]="hide ? 'password' : 'text'" placeholder="Password"
                        formControlName="password" required>
                    <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
                        [attr.aria-pressed]="hide">
                        <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                    </button>
                </mat-form-field>
                <button mat-raised-button color="primary" [disabled]="!form.valid" (click)="onSubmit()">Login</button>
            </form>
        </mat-card-content>
    </mat-card>
</div>